import { LOGIN_METHOD_KEY } from 'root-constants'

export const getLoginMethodFromLocalStorage = (): string =>
  localStorage.getItem(LOGIN_METHOD_KEY) || ''
